import { createContext } from "react";

const ProductGuidanceContext = createContext(undefined);

export default ProductGuidanceContext;
